import { extend } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
import app from 'flarum/forum/app';
import CommentPost from 'flarum/forum/components/CommentPost';
import PostControls from 'flarum/forum/utils/PostControls';
import BookmarkButton from './components/BookmarkButton';
/**
 * Where the admin has chosen to show the post bookmark control.
 *
 * A default is registered in extend.php, so this is always one of the three positions.
 */
function buttonPosition() {
  return app.forum.attribute('fof-bookmarks.postButtonPosition');
}
export default function addPostControls() {
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const post = this.attrs.post;
    if (buttonPosition() === 'header') {
      if (!app.session.user) return;
      items.add('bookmark', m(BookmarkButton, {
        subject: post,
        labels: "postButton",
        className: "Button Button--link Button--bookmark-post",
        alert: true
      }));
      return;
    }

    // With the button moved elsewhere, an optional label keeps bookmarked posts
    // recognisable while scrolling.
    if (app.forum.attribute('fof-bookmarks.postHeaderBadge') && post.bookmarked()) {
      items.add('bookmark', m("span", {
        className: "BookmarkedPostLabel"
      }, m(Icon, {
        name: "fas fa-bookmark"
      }), " ", app.translator.trans('fof-bookmarks.forum.badge')));
    }
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    if (!app.session.user || buttonPosition() !== 'actions') return;
    items.add('bookmark', m(BookmarkButton, {
      subject: this.attrs.post,
      labels: "postButton",
      className: "Button Button--link",
      alert: true
    }), 80);
  });
  extend(PostControls, 'userControls', function (items, post) {
    if (!app.session.user || buttonPosition() !== 'menu') return;

    // No `className`: dropdown items are styled by the menu, and core's own PostControls
    // entries (Edit, Flag, Delete) pass none either. Adding `Button` here indents the row.
    items.add('bookmark', m(BookmarkButton, {
      subject: post,
      labels: "postButton",
      alert: true
    }));
  });
}